import React from 'react'
import { Link } from 'react-router-dom'

import logo from '../../assets/logo.png'
import { BsTwitter, BsFacebook, BsInstagram, BsLinkedin } from 'react-icons/bs'
// import env from '../../assets/env.png'
// import twitter from '../../assets/twitter.png'
// import facebook from '../../assets/facebook.png'
// import instagram from '../../assets/instagram.png'
// import telegram from '../../assets/telegram.png'
// import youtube from '../../assets/youtube.png'

const Footer = () => {
	return (
		<footer className='section novi-background footer-advanced bg-gray-700'>
			<div className='footer-advanced-main'>
				<div className='container'>
					<div className='row row-50'>
						<div className='col-lg-4'>
							<h5 className='font-weight-bold text-uppercase text-white'>
								About Us
							</h5>
							<p className='footer-advanced-text'>
								Showel Global Properties Limited was formed to provide
								commercial real estate services such as brokerage, property
								management, property development, and investment. We aim to
								change the real estate market by understanding and meeting our
								clients' property needs and delivering a start to finish results
								to our clients, prospects, and investors. With over 15 years of
								combined experience and integrity as our watchword, Showel
								Global Properties Limited is on course to becoming one of the
								most reliable real estate companies in Nigeria and beyond
							</p>
						</div>

						<div className='col-sm-7 col-md-5 col-lg-4'>
							<h5 className='font-weight-bold text-uppercase text-white'>
								Useful Links
							</h5>
							<div className='footer-advanced-aside'>
								<div className='container'>
									<div className='footer-advanced-layout'>
										<div>
											<ul className='list-nav'>
												<li>
													<Link to='index.html'>Home</Link>
												</li>
												<li>
													<Link to='about-us.html'>About</Link>
												</li>
												<li>
													<Link to='#'>Properties</Link>
												</li>
												<li>
													<Link to='#'>Blog</Link>
												</li>
												<li>
													<Link to='contacts.html'>Contacts</Link>
												</li>
											</ul>
										</div>
										<div className='mt-5'>
											<ul className='list-inline list-inline-md d-flex justify-content-center text-center m;-auto mr-auto'>
												<li>
													<Link
														className='icon novi-icon icon-sm link-default mdi mdi-facebook'
														to='#'
													>
														<BsFacebook size='20' />
													</Link>
												</li>
												<li>
													<Link
														className='icon novi-icon icon-sm link-default mdi mdi-twitter'
														to='#'
													>
														<BsTwitter size='20' />
													</Link>
												</li>
												<li>
													<Link
														className='icon novi-icon icon-sm link-default mdi mdi-instagram'
														to='#'
													>
														<BsInstagram size='20' />
													</Link>
												</li>
												<li>
													<Link
														className='icon novi-icon icon-sm link-default mdi mdi-linkedin'
														to='#'
													>
														<BsLinkedin size='20' />
													</Link>
												</li>
											</ul>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div className='col-sm-5 col-md-7 col-lg-4'>
							<h5 className='font-weight-bold text-uppercase text-white'>
								Gallery
							</h5>
							<div className='row row-x-10' data-lightgallery='group'>
								<div className='col-3 col-sm-4 col-md-3'>
									<Link
										className='thumbnail-minimal'
										to='images/gallery-original-1.jpg'
										data-lightgallery='item'
									>
										<img
											className='thumbnail-minimal-image'
											src='images/footer-gallery-1-85x85.jpg'
											alt=''
										/>
										<div className='thumbnail-minimal-caption'></div>
									</Link>
								</div>
								<div className='col-3 col-sm-4 col-md-3'>
									<Link
										className='thumbnail-minimal'
										to='images/gallery-original-2.jpg'
										data-lightgallery='item'
									>
										<img
											className='thumbnail-minimal-image'
											src='images/footer-gallery-2-85x85.jpg'
											alt=''
										/>
										<div className='thumbnail-minimal-caption'></div>
									</Link>
								</div>
								<div className='col-3 col-sm-4 col-md-3'>
									<Link
										className='thumbnail-minimal'
										to='images/gallery-original-3.jpg'
										data-lightgallery='item'
									>
										<img
											className='thumbnail-minimal-image'
											src='images/footer-gallery-3-85x85.jpg'
											alt=''
										/>
										<div className='thumbnail-minimal-caption'></div>
									</Link>
								</div>
								<div className='col-3 col-sm-4 col-md-3'>
									<Link
										className='thumbnail-minimal'
										to='images/gallery-original-4.jpg'
										data-lightgallery='item'
									>
										<img
											className='thumbnail-minimal-image'
											src='images/footer-gallery-4-85x85.jpg'
											alt=''
										/>
										<div className='thumbnail-minimal-caption'></div>
									</Link>
								</div>
								<div className='col-3 col-sm-4 col-md-3'>
									<Link
										className='thumbnail-minimal'
										to='images/gallery-original-5.jpg'
										data-lightgallery='item'
									>
										<img
											className='thumbnail-minimal-image'
											src='images/footer-gallery-5-85x85.jpg'
											alt=''
										/>
										<div className='thumbnail-minimal-caption'></div>
									</Link>
								</div>
								<div className='col-3 col-sm-4 col-md-3'>
									<Link
										className='thumbnail-minimal'
										to='images/gallery-original-6.jpg'
										data-lightgallery='item'
									>
										<img
											className='thumbnail-minimal-image'
											src='images/footer-gallery-6-85x85.jpg'
											alt=''
										/>
										<div className='thumbnail-minimal-caption'> </div>
									</Link>
								</div>
								<div className='col-3 col-sm-4 col-md-3'>
									<Link
										className='thumbnail-minimal'
										to='images/gallery-original-7.jpg'
										data-lightgallery='item'
									>
										<img
											className='thumbnail-minimal-image'
											src='images/footer-gallery-7-85x85.jpg'
											alt=''
										/>
										<div className='thumbnail-minimal-caption'></div>
									</Link>
								</div>
								<div className='col-3 col-sm-4 col-md-3'>
									<Link
										className='thumbnail-minimal'
										to='images/gallery-original-8.jpg'
										data-lightgallery='item'
									>
										<img
											className='thumbnail-minimal-image'
											src='images/footer-gallery-8-85x85.jpg'
											alt=''
										/>
										<div className='thumbnail-minimal-caption'></div>
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className='container'>
				<hr />
			</div>
			<div className='footer-advanced-aside'>
				<div className='container'>
					<div className='footer-advanced-layout d-flex justify-space-between'>
						<Link className='brand' to='index.html'>
							<img src={logo} alt='' width='115' height='34' srcSet={logo} />
						</Link>

						<p className='rights'>
							<span>&copy;&nbsp;</span>
							<span className='copyright-year'></span>Showel Global Limited. All
							Rights Reserved.
						</p>
					</div>
				</div>
			</div>
		</footer>
	)
}

export default Footer
